export default "__VITE_ASSET__BBB6HKsC__"